export const COLOR_PRIMARY = "#052659";
export const COLOR_LIGHT_BLUE = "#A9C7E8";
export const COLOR_DARK_BLUE_TEXT = "#2C3E50";
export const COLOR_WHITE = "#FFFFFF";
export const COLOR_BLACK = "#000000";
export const COLOR_BLOG_BG = "#F8F8FA";

export const COLOR_YELLOW = "#F8B500";
export const COLOR_BROWN = "#502700";
export const COLOR_ORANGE = "#E66231";
export const COLOR_GRAY = "#999999";
export const COLOR_DARK_GRAY = "#333333";
export const COLOR_LIGHT_GRAY = "#F4F4F4";
export const COLOR_GRAY_BACKGROUND = "#EFEFEF";
export const COLOR_DISABLED = "#CACACA";
export const COLOR_LIGHT_RED = "#FDEDED";


